import { TEudrPlansResponse } from 'redux/reducers/eudr/types';
import { EParamType, EStepType, Step } from './types';

export const stepsConfig = (eudrPlans: TEudrPlansResponse): Step[] => [
	{
		id: '1',
		question: 'Would you like to make changes to your subscription plan?',
		stepType: EStepType.YES_NO,
		yes: '2',
		no: '3',
	},
	{
		id: '2',
		question: 'Select new subscription plan: dropdown with subscritpion plans',
		stepType: EStepType.NEXT,
		params: [
			{
				param: 'new_plan_id',
				name: 'Subscription plan update',
				paramType: EParamType.SELECT,
				options: (eudrPlans ?? []).map((p) => ({ id: p.id, name: p.name })),
			},
			{
				param: 'new_number_of_additional_products',
				name: 'Change number of additional products to',
				paramType: EParamType.NUMBER,
			},
		],
	},
	{
		id: '3',
		question: 'Would you like to add more product type(s) to your account?',
		stepType: EStepType.YES_NO,
		yes: '4',
		no: '5',
	},
	{
		id: '4',
		question:
			'Please provide detailed information regarding the new product(s) you wish to add to your account. \nLinks to the product page will greatly help in processing.',
		stepType: EStepType.NEXT,
		params: [
			{
				param: 'new_product_types',
				name: 'Add product type(s)',
				paramType: EParamType.TEXT,
			},
		],
	},
	{
		id: '5',
		question: 'Would you like to update your product type(s)?',
		stepType: EStepType.YES_NO,
		yes: '6',
		no: '7',
	},
	{
		id: '6',
		question:
			'Please provide detailed information regarding the product(s) you wish to modify. Include the current product(s) name as well as the desired changes. \nPlease note that when referring to changes in the product type, we are specifically referring to modifications that may affect the applicable list of regulations and legislation.',
		stepType: EStepType.NEXT,
		params: [
			{
				param: 'product_changes',
				name: 'Change product type(s)',
				paramType: EParamType.TEXT,
			},
		],
	},
	{
		id: '7',
		question: 'Would you like to remove products from your account?',
		stepType: EStepType.YES_NO,
		yes: '8',
		no: '9',
	},
	{
		id: '8',
		question: 'Please specify the product type(s) you would like to remove from your account.',
		stepType: EStepType.NEXT,
		params: [
			{
				param: 'products_remove',
				name: 'Remove product type(s)',
				paramType: EParamType.TEXT,
			},
		],
	},
	{
		id: '9',
		question:
			'Please review all the changes you are about to submit and confirm. If you wish to make any adjustments, you can click the "Back" button to modify your requests.',
		stepType: EStepType.SUBMIT,
	},
];
